import React, { useEffect, useState, useMemo } from "react";
import { Typography, Layout, Col } from "antd";
import { useSelector } from "react-redux";
import { groupBy } from "lodash";
import { selectUser } from "../../store/selector";
import { useTranslation } from "react-i18next";
import { getRandomSuggestedQuestionsAIChatBot as getRandomSuggestedQuestionsAPI } from "../../api/api";
import { useFetch } from "../../hooks/fetch";
import ErrorMessage from "../customComponent/customMessages/ErrorMessage";
import {
  IntroPanelContainerStyle,
  IntroPanelHelloTextStyle,
  IntroPanelHowCanIHelpTextStyle,
  IntroPanelSelectCategoryTextStyle,
  IntroPanelQuestionsContainerStyle
} from "./Styles";
import { SuggestedQuestionsCard } from "./SuggestedQuestionsCard";

const { Text } = Typography;
const { Content } = Layout;
const LIMIT = 2;

const suggestedThemes = Object.freeze([
  {
    title: "Program Assistance",
    agent: "assistance_program_search",
    theme: "programs"
  },
  {
    title: "Patient Discovery",
    theme: "patients",
    agent: "patients_discovery"
  },
  {
    title: "Patient Details",
    theme: "specific patients",
    agent: "specific_patient_search"
  }
]);

const IntroPanel = ({ onSuggestedQuestionClick }) => {
  const { t } = useTranslation();
  const { isIntroPanelShown } = useSelector((state) => state.aiChatBot);
  const user = useSelector(selectUser);
  const [suggestedQuestions, setSuggestedQuestions] = useState(null);

  const [getRandomSuggestedQuestions, getRandomSuggestedQuestionsResult, , getRandomSuggestedQuestionsError] =
    useFetch(getRandomSuggestedQuestionsAPI);

  useEffect(() => {
    if (user) {
      getRandomSuggestedQuestions(LIMIT);
    }
  }, [user]);

  useEffect(() => {
    if (getRandomSuggestedQuestionsError) {
      ErrorMessage(t("ai_chat_bot.errors.failed_fetching_suggested_questions"));
    }
  }, [getRandomSuggestedQuestionsError, t]);

  useEffect(() => {
    if (getRandomSuggestedQuestionsResult) {
      const randomSuggestedQuestions = getRandomSuggestedQuestionsResult?.data;
      if (randomSuggestedQuestions?.length) {
        setSuggestedQuestions(groupBy(randomSuggestedQuestions, (question) => question.agent));
      }
    }
  }, [getRandomSuggestedQuestionsResult]);

  const suggestedQuestionsCards = useMemo(
    () =>
      suggestedQuestions &&
      suggestedThemes.map(({ title, theme, agent }) => (
        <SuggestedQuestionsCard
          key={title}
          {...{ title, theme, onSuggestedQuestionClick }}
          questions={(suggestedQuestions[agent] || []).map(({ text }) => text) ?? []}
        />
      )),
    [suggestedQuestions]
  );

  return (
    <Content style={{ ...IntroPanelContainerStyle, visibility: isIntroPanelShown ? "visible" : "hidden" }}>
      <Col>
        <Text style={IntroPanelHelloTextStyle}>
          {t("ai_chat_bot.intro_panel.hello_message", {
            firstName: user?.firstName
          })}
        </Text>
        <Text style={IntroPanelHowCanIHelpTextStyle}>{t("ai_chat_bot.intro_panel.how_can_i_help")}</Text>
      </Col>
      <Text style={IntroPanelSelectCategoryTextStyle}>{t("ai_chat_bot.intro_panel.select_category")}</Text>

      <Col style={IntroPanelQuestionsContainerStyle}>{suggestedQuestionsCards}</Col>
    </Content>
  );
};

export { IntroPanel };
